var map = {
	"./Aircraft/Airliner_Black.png": 58,
	"./Aircraft/Airliner_Blue.png": 1115,
	"./Aircraft/Airliner_Green.png": 1116,
	"./Aircraft/Airliner_Grey.png": 1117,
	"./Aircraft/Airliner_Red.png": 1118,
	"./Aircraft/Airliner_Yellow.png": 1119,
	"./Aircraft/Airplane_Black.png": 1120,
	"./Aircraft/Airplane_Blue.png": 1121,
	"./Aircraft/Airplane_Green.png": 1122,
	"./Aircraft/Airplane_Grey.png": 1123,
	"./Aircraft/Airplane_Red.png": 1124,
	"./Aircraft/Airplane_Yellow.png": 1125,
	"./Aircraft/Helicopter_Black.png": 1126,
	"./Aircraft/Helicopter_Blue.png": 1127,
	"./Aircraft/Helicopter_Green.png": 1128,
	"./Aircraft/Helicopter_Grey.png": 1129,
	"./Aircraft/Helicopter_Red.png": 1130,
	"./Aircraft/Helicopter_Yellow.png": 1131,
	"./Arrows/093-chevron-1.png": 1132,
	"./Arrows/093-chevron-10.png": 1133,
	"./Arrows/093-chevron-11.png": 1134,
	"./Arrows/093-chevron-2.png": 1135,
	"./Arrows/093-chevron-3.png": 1136,
	"./Arrows/093-chevron-4.png": 1137,
	"./Arrows/093-chevron-5.png": 1138,
	"./Arrows/093-chevron-6.png": 1139,
	"./Arrows/093-chevron-7.png": 1140,
	"./Arrows/093-chevron-8.png": 1141,
	"./Arrows/093-chevron-9.png": 1142,
	"./Arrows/093-chevron.png": 1143,
	"./Arrows/093-compress-1.png": 1144,
	"./Arrows/093-compress.png": 1145,
	"./Arrows/093-curved-arrow-1.png": 1146,
	"./Arrows/093-curved-arrow-2.png": 1147,
	"./Arrows/093-curved-arrow-3.png": 1148,
	"./Arrows/093-curved-arrow.png": 1149,
	"./Arrows/093-diagonal-arrow-1.png": 1150,
	"./Arrows/093-diagonal-arrow-10.png": 1151,
	"./Arrows/093-diagonal-arrow-11.png": 1152,
	"./Arrows/093-diagonal-arrow-12.png": 1153,
	"./Arrows/093-diagonal-arrow-13.png": 1154,
	"./Arrows/093-diagonal-arrow-14.png": 1155,
	"./Arrows/093-diagonal-arrow-15.png": 1156,
	"./Arrows/093-diagonal-arrow-2.png": 1157,
	"./Arrows/093-diagonal-arrow-3.png": 1158,
	"./Arrows/093-diagonal-arrow-4.png": 1159,
	"./Arrows/093-diagonal-arrow-5.png": 1160,
	"./Arrows/093-diagonal-arrow-6.png": 1161,
	"./Arrows/093-diagonal-arrow-7.png": 1162,
	"./Arrows/093-diagonal-arrow-8.png": 1163,
	"./Arrows/093-diagonal-arrow-9.png": 1164,
	"./Arrows/093-diagonal-arrow.png": 1165,
	"./Arrows/093-down-arrow-1.png": 1166,
	"./Arrows/093-down-arrow-2.png": 1167,
	"./Arrows/093-down-arrow-3.png": 1168,
	"./Arrows/093-down-arrow-4.png": 1169,
	"./Arrows/093-down-arrow-5.png": 1170,
	"./Arrows/093-down-arrow.png": 1171,
	"./Arrows/093-exchange-1.png": 1172,
	"./Arrows/093-exchange.png": 1173,
	"./Arrows/093-expand-1.png": 1174,
	"./Arrows/093-expand-2.png": 1175,
	"./Arrows/093-expand-3.png": 1176,
	"./Arrows/093-expand.png": 1177,
	"./Arrows/093-left-arrow-1.png": 1178,
	"./Arrows/093-left-arrow-2.png": 1179,
	"./Arrows/093-left-arrow-3.png": 1180,
	"./Arrows/093-left-arrow-4.png": 1181,
	"./Arrows/093-left-arrow-5.png": 1182,
	"./Arrows/093-left-arrow-6.png": 1183,
	"./Arrows/093-left-arrow.png": 1184,
	"./Arrows/093-move-1.png": 1185,
	"./Arrows/093-move.png": 1186,
	"./Arrows/093-redo-1.png": 1187,
	"./Arrows/093-redo.png": 1188,
	"./Arrows/093-resize-1.png": 1189,
	"./Arrows/093-resize-2.png": 1190,
	"./Arrows/093-resize-3.png": 1191,
	"./Arrows/093-resize.png": 1192,
	"./Arrows/093-right-arrow-1.png": 1193,
	"./Arrows/093-right-arrow-2.png": 1194,
	"./Arrows/093-right-arrow-3.png": 1195,
	"./Arrows/093-right-arrow-4.png": 1196,
	"./Arrows/093-right-arrow-5.png": 1197,
	"./Arrows/093-right-arrow-6.png": 1198,
	"./Arrows/093-right-arrow-7.png": 1199,
	"./Arrows/093-right-arrow.png": 1200,
	"./Arrows/093-scroll-1.png": 1201,
	"./Arrows/093-scroll.png": 1202,
	"./Arrows/093-sort-1.png": 1203,
	"./Arrows/093-sort-2.png": 1204,
	"./Arrows/093-sort-3.png": 1205,
	"./Arrows/093-sort.png": 1206,
	"./Arrows/093-turn-left-1.png": 1207,
	"./Arrows/093-turn-left-2.png": 1208,
	"./Arrows/093-turn-left-3.png": 1209,
	"./Arrows/093-turn-left.png": 1210,
	"./Arrows/093-turn-right-1.png": 1211,
	"./Arrows/093-turn-right-2.png": 1212,
	"./Arrows/093-turn-right-3.png": 1213,
	"./Arrows/093-turn-right.png": 1214,
	"./Arrows/093-undo-1.png": 1215,
	"./Arrows/093-undo.png": 1216,
	"./Arrows/093-up-arrow-1.png": 1217,
	"./Arrows/093-up-arrow-2.png": 1218,
	"./Arrows/093-up-arrow-3.png": 1219,
	"./Arrows/093-up-arrow-4.png": 1220,
	"./Arrows/093-up-arrow-5.png": 1221,
	"./Arrows/093-up-arrow-6.png": 1222,
	"./Arrows/093-up-arrow.png": 1223,
	"./Assets/151-actions.png": 1224,
	"./Assets/151-advert.png": 1225,
	"./Assets/151-antennas.png": 1226,
	"./Assets/151-archives.png": 1227,
	"./Assets/151-attached.png": 1228,
	"./Assets/151-banker.png": 1229,
	"./Assets/151-barrow.png": 1230,
	"./Assets/151-bed-side.png": 1231,
	"./Assets/151-beds.png": 1232,
	"./Assets/151-blackboard.png": 1233,
	"./Assets/151-blocked.png": 1234,
	"./Assets/151-book-bag-1.png": 1235,
	"./Assets/151-book-bag.png": 1236,
	"./Assets/151-bridges.png": 1237,
	"./Assets/151-calculations.png": 1238,
	"./Assets/151-carrier.png": 1239,
	"./Assets/151-ceremonial.png": 1240,
	"./Assets/151-chairs.png": 1241,
	"./Assets/151-cleaned.png": 1242,
	"./Assets/151-closing.png": 1243,
	"./Assets/151-cooling.png": 1244,
	"./Assets/151-demostration.png": 1245,
	"./Assets/151-deposit.png": 1246,
	"./Assets/151-dialogue.png": 1247,
	"./Assets/151-disturbance.png": 1248,
	"./Assets/151-domestic-phone.png": 1249,
	"./Assets/151-door-key.png": 1250,
	"./Assets/151-door.png": 1251,
	"./Assets/151-doorway.png": 1252,
	"./Assets/151-draws.png": 1253,
	"./Assets/151-driller.png": 1254,
	"./Assets/151-electric-1.png": 1255,
	"./Assets/151-electric-2.png": 1256,
	"./Assets/151-electric.png": 1257,
	"./Assets/151-entrance.png": 1258,
	"./Assets/151-facade-1.png": 1259,
	"./Assets/151-facade.png": 1260,
	"./Assets/151-fader.png": 1261,
	"./Assets/151-file-storage.png": 1262,
	"./Assets/151-fireplace-1.png": 1263,
	"./Assets/151-fireplace.png": 1264,
	"./Assets/151-flats-1.png": 1265,
	"./Assets/151-flats.png": 1266,
	"./Assets/151-frame.png": 1267,
	"./Assets/151-garden-work.png": 1268,
	"./Assets/151-gardener.png": 1269,
	"./Assets/151-gardening.png": 1270,
	"./Assets/151-glamour.png": 1271,
	"./Assets/151-graphic-design.png": 1272,
	"./Assets/151-graphs.png": 1273,
	"./Assets/151-hacksaw.png": 1274,
	"./Assets/151-hand-gesture.png": 1275,
	"./Assets/151-hand-phones.png": 1276,
	"./Assets/151-headphones.png": 1277,
	"./Assets/151-health-care.png": 1278,
	"./Assets/151-hearth.png": 1279,
	"./Assets/151-house-things-1.png": 1280,
	"./Assets/151-house-things-2.png": 1281,
	"./Assets/151-house-things.png": 1282,
	"./Assets/151-house.png": 1283,
	"./Assets/151-houses.png": 1284,
	"./Assets/151-indoor.png": 1285,
	"./Assets/151-industrial-park.png": 1286,
	"./Assets/151-industrial.png": 1287,
	"./Assets/151-interior-design.png": 1288,
	"./Assets/151-invention.png": 1289,
	"./Assets/151-keyword.png": 1290,
	"./Assets/151-kilograms.png": 1291,
	"./Assets/151-ladders.png": 1292,
	"./Assets/151-line-chart.png": 1293,
	"./Assets/151-lover.png": 1294,
	"./Assets/151-mail.png": 1295,
	"./Assets/151-mailed.png": 1296,
	"./Assets/151-mallet.png": 1297,
	"./Assets/151-mansory.png": 1298,
	"./Assets/151-maps-and-flags-1.png": 1299,
	"./Assets/151-maps-and-flags-2.png": 1300,
	"./Assets/151-maps-and-flags-3.png": 1301,
	"./Assets/151-maps-and-flags-4.png": 1302,
	"./Assets/151-maps-and-flags-5.png": 1303,
	"./Assets/151-maps-and-flags-6.png": 1304,
	"./Assets/151-maps-and-flags.png": 1305,
	"./Assets/151-measuring-1.png": 1306,
	"./Assets/151-measuring.png": 1307,
	"./Assets/151-mechanics.png": 1308,
	"./Assets/151-metallic-blind.png": 1309,
	"./Assets/151-money-icons.png": 1310,
	"./Assets/151-monumental.png": 1311,
	"./Assets/151-motorhome.png": 1312,
	"./Assets/151-online-store.png": 1313,
	"./Assets/151-packaging.png": 1314,
	"./Assets/151-paint-roller.png": 1315,
	"./Assets/151-painted.png": 1316,
	"./Assets/151-paper-printer.png": 1317,
	"./Assets/151-paper-work.png": 1318,
	"./Assets/151-picket.png": 1319,
	"./Assets/151-pincers.png": 1320,
	"./Assets/151-plan.png": 1321,
	"./Assets/151-plans.png": 1322,
	"./Assets/151-plumbering-1.png": 1323,
	"./Assets/151-plumbering.png": 1324,
	"./Assets/151-printed.png": 1325,
	"./Assets/151-property.png": 1326,
	"./Assets/151-pruners.png": 1327,
	"./Assets/151-purses.png": 1328,
	"./Assets/151-radiators.png": 1329,
	"./Assets/151-reading-glasses.png": 1330,
	"./Assets/151-real-estate-1.png": 1331,
	"./Assets/151-real-estate-2.png": 1332,
	"./Assets/151-real-estate-3.png": 1333,
	"./Assets/151-real-estate-4.png": 1334,
	"./Assets/151-real-estate-5.png": 1335,
	"./Assets/151-real-estate-6.png": 1336,
	"./Assets/151-real-estate.png": 1337,
	"./Assets/151-relax.png": 1338,
	"./Assets/151-religious.png": 1339,
	"./Assets/151-rent.png": 1340,
	"./Assets/151-reparation.png": 1341,
	"./Assets/151-roof.png": 1342,
	"./Assets/151-sand-clock.png": 1343,
	"./Assets/151-savings.png": 1344,
	"./Assets/151-security-system-1.png": 1345,
	"./Assets/151-security-system.png": 1346,
	"./Assets/151-seventeen.png": 1347,
	"./Assets/151-shower.png": 1348,
	"./Assets/151-single.png": 1349,
	"./Assets/151-sit-down.png": 1350,
	"./Assets/151-skyline.png": 1351,
	"./Assets/151-step-ladder.png": 1352,
	"./Assets/151-storehouse.png": 1353,
	"./Assets/151-studying.png": 1354,
	"./Assets/151-switch-off.png": 1355,
	"./Assets/151-text-file.png": 1356,
	"./Assets/151-title.png": 1357,
	"./Assets/151-tools-and-utensils.png": 1358,
	"./Assets/151-transportation.png": 1359,
	"./Assets/151-trees.png": 1360,
	"./Assets/151-trucks-1.png": 1361,
	"./Assets/151-trucks.png": 1362,
	"./Assets/151-turned-off.png": 1363,
	"./Assets/151-up-1.png": 1364,
	"./Assets/151-up-2.png": 1365,
	"./Assets/151-up.png": 1366,
	"./Assets/151-ventilation.png": 1367,
	"./Assets/151-wc.png": 1368,
	"./Assets/151-wheel-chair.png": 1369,
	"./Assets/151-wheelbarrow.png": 1370,
	"./Assets/151-winch.png": 1371,
	"./Assets/151-work-tools.png": 1372,
	"./Assets/151-worker.png": 1373,
	"./Bikes/Bicycle_Black.png": 1374,
	"./Bikes/Bicycle_Blue.png": 1375,
	"./Bikes/Bicycle_Green.png": 1376,
	"./Bikes/Bicycle_Grey.png": 1377,
	"./Bikes/Bicycle_Red.png": 1378,
	"./Bikes/Bicycle_Yellow.png": 1379,
	"./Bikes/CruiserMotorcycle_Black.png": 1380,
	"./Bikes/CruiserMotorcycle_Blue.png": 1381,
	"./Bikes/CruiserMotorcycle_Green.png": 1382,
	"./Bikes/CruiserMotorcycle_Grey.png": 1383,
	"./Bikes/CruiserMotorcycle_Red.png": 1384,
	"./Bikes/CruiserMotorcycle_Yellow.png": 1385,
	"./Bikes/Motorcycle_Black.png": 1386,
	"./Bikes/Motorcycle_Blue.png": 1387,
	"./Bikes/Motorcycle_Green.png": 1388,
	"./Bikes/Motorcycle_Grey.png": 1389,
	"./Bikes/Motorcycle_Red.png": 1390,
	"./Bikes/Motorcycle_Yellow.png": 1391,
	"./Bikes/QuadBike_Black.png": 1392,
	"./Bikes/QuadBike_Blue.png": 1393,
	"./Bikes/QuadBike_Green.png": 1394,
	"./Bikes/QuadBike_Grey.png": 1395,
	"./Bikes/QuadBike_Red.png": 1396,
	"./Bikes/QuadBike_Yellow.png": 1397,
	"./Bikes/Scooter_Black.png": 1398,
	"./Bikes/Scooter_Blue.png": 1399,
	"./Bikes/Scooter_Green.png": 1400,
	"./Bikes/Scooter_Grey.png": 1401,
	"./Bikes/Scooter_Red.png": 1402,
	"./Bikes/Scooter_Yellow.png": 1403,
	"./Bikes/TouringMotorcycle_Black.png": 1404,
	"./Bikes/TouringMotorcycle_Blue.png": 1405,
	"./Bikes/TouringMotorcycle_Gray.png": 1406,
	"./Bikes/TouringMotorcycle_Green.png": 1407,
	"./Bikes/TouringMotorcycle_Red.png": 1408,
	"./Bikes/TouringMotorcycle_Yellow.png": 1409,
	"./Car/Cabriolet_Black.png": 1410,
	"./Car/Cabriolet_Blue.png": 1411,
	"./Car/Cabriolet_Green.png": 1412,
	"./Car/Cabriolet_Grey.png": 1413,
	"./Car/Cabriolet_Red.png": 1414,
	"./Car/Cabriolet_Yellow.png": 1415,
	"./Car/CamperVan_Black.png": 1416,
	"./Car/CamperVan_Blue.png": 1417,
	"./Car/CamperVan_Green.png": 1418,
	"./Car/CamperVan_Grey.png": 1419,
	"./Car/CamperVan_Red.png": 1420,
	"./Car/CamperVan_Yellow.png": 1421,
	"./Car/Car_Black.png": 1422,
	"./Car/Car_Blue.png": 1423,
	"./Car/Car_Green.png": 1424,
	"./Car/Car_Grey.png": 1425,
	"./Car/Car_Red.png": 1426,
	"./Car/Car_Yellow.png": 1427,
	"./Car/ExecutiveCar_Black.png": 1428,
	"./Car/ExecutiveCar_Blue.png": 1429,
	"./Car/ExecutiveCar_Green.png": 1430,
	"./Car/ExecutiveCar_Grey.png": 1431,
	"./Car/ExecutiveCar_Red.png": 1432,
	"./Car/ExecutiveCar_Yellow.png": 1433,
	"./Car/Hatchback_Black.png": 1434,
	"./Car/Hatchback_Blue.png": 1435,
	"./Car/Hatchback_Green.png": 1436,
	"./Car/Hatchback_Grey.png": 1437,
	"./Car/Hatchback_Red.png": 1438,
	"./Car/Hatchback_Yellow.png": 1439,
	"./Car/HybridCar_Black.png": 1440,
	"./Car/HybridCar_Blue.png": 1441,
	"./Car/HybridCar_Green.png": 1442,
	"./Car/HybridCar_Grey.png": 1443,
	"./Car/HybridCar_Red.png": 1444,
	"./Car/HybridCar_Yellow.png": 1445,
	"./Car/Jeep_Black.png": 1446,
	"./Car/Jeep_Blue.png": 1447,
	"./Car/Jeep_Green.png": 1448,
	"./Car/Jeep_Grey.png": 1449,
	"./Car/Jeep_Red.png": 1450,
	"./Car/Jeep_Yellow.png": 1451,
	"./Car/Limousine_Black.png": 1452,
	"./Car/Limousine_Blue.png": 1453,
	"./Car/Limousine_Green.png": 1454,
	"./Car/Limousine_Grey.png": 1455,
	"./Car/Limousine_Red.png": 1456,
	"./Car/Limousine_Yellow.png": 1457,
	"./Car/LuxuryCar__Black.png": 1458,
	"./Car/LuxuryCar__Blue.png": 1459,
	"./Car/LuxuryCar__Gray.png": 1460,
	"./Car/LuxuryCar__Green.png": 1461,
	"./Car/LuxuryCar__Red.png": 1462,
	"./Car/LuxuryCar__Yellow.png": 1463,
	"./Car/MUV_Black.png": 1464,
	"./Car/MUV_Blue.png": 1465,
	"./Car/MUV_Green.png": 1466,
	"./Car/MUV_Grey.png": 1467,
	"./Car/MUV_Red.png": 1468,
	"./Car/MUV_Yellow.png": 1469,
	"./Car/Minibus_Black.png": 1470,
	"./Car/Minibus_Blue.png": 1471,
	"./Car/Minibus_Green.png": 1472,
	"./Car/Minibus_Grey.png": 1473,
	"./Car/Minibus_Red.png": 1474,
	"./Car/Minibus_Yellow.png": 1475,
	"./Car/MinicarTrailer_Black.png": 1476,
	"./Car/MinicarTrailer_Blue.png": 1477,
	"./Car/MinicarTrailer_Green.png": 1478,
	"./Car/MinicarTrailer_Grey.png": 1479,
	"./Car/MinicarTrailer_Red.png": 1480,
	"./Car/MinicarTrailer_Yellow.png": 1481,
	"./Car/Minicar_Black.png": 1482,
	"./Car/Minicar_Blue.png": 1483,
	"./Car/Minicar_Green.png": 1484,
	"./Car/Minicar_Grey.png": 1485,
	"./Car/Minicar_Red.png": 1486,
	"./Car/Minicar_Yellow.png": 1487,
	"./Car/Minitruck_Black.png": 1488,
	"./Car/Minitruck_Blue.png": 1489,
	"./Car/Minitruck_Green.png": 1490,
	"./Car/Minitruck_Grey.png": 1491,
	"./Car/Minitruck_Red.png": 1492,
	"./Car/Minitruck_Yellow.png": 1493,
	"./Car/PanelVan_Black.png": 1494,
	"./Car/PanelVan_Blue.png": 1495,
	"./Car/PanelVan_Green.png": 1496,
	"./Car/PanelVan_Grey.png": 1497,
	"./Car/PanelVan_Red.png": 1498,
	"./Car/PanelVan_Yellow.png": 1499,
	"./Car/Pickup_Black.png": 1500,
	"./Car/Pickup_Blue.png": 1501,
	"./Car/Pickup_Green.png": 1502,
	"./Car/Pickup_Grey.png": 1503,
	"./Car/Pickup_Red.png": 1504,
	"./Car/Pickup_Yellow.png": 1505,
	"./Car/SUV_Black.png": 1506,
	"./Car/SUV_Blue.png": 1507,
	"./Car/SUV_Green.png": 1508,
	"./Car/SUV_Grey.png": 1509,
	"./Car/SUV_Red.png": 1510,
	"./Car/SUV_Yellow.png": 1511,
	"./Car/ServiceVan_Black.png": 1512,
	"./Car/ServiceVan_Blue.png": 1513,
	"./Car/ServiceVan_Green.png": 1514,
	"./Car/ServiceVan_Grey.png": 1515,
	"./Car/ServiceVan_Red.png": 1516,
	"./Car/ServiceVan_Yellow.png": 1517,
	"./Car/SportsCar_Black.png": 1518,
	"./Car/SportsCar_Blue.png": 1519,
	"./Car/SportsCar_Green.png": 1520,
	"./Car/SportsCar_Grey.png": 1521,
	"./Car/SportsCar_Red.png": 1522,
	"./Car/SportsCar_Yellow.png": 1523,
	"./Car/StationWagon_Black.png": 1524,
	"./Car/StationWagon_Blue.png": 1525,
	"./Car/StationWagon_Green.png": 1526,
	"./Car/StationWagon_Grey.png": 1527,
	"./Car/StationWagon_Red.png": 1528,
	"./Car/StationWagon_Yellow.png": 1529,
	"./Car/Van_Black.png": 1530,
	"./Car/Van_Blue.png": 1531,
	"./Car/Van_Green.png": 1532,
	"./Car/Van_Grey.png": 1533,
	"./Car/Van_Red.png": 1534,
	"./Car/Van_Yellow.png": 1535,
	"./Ecommerce/auction.png": 1536,
	"./Ecommerce/badge-1.png": 1537,
	"./Ecommerce/badge-2.png": 1538,
	"./Ecommerce/badge-3.png": 1539,
	"./Ecommerce/badge-4.png": 1540,
	"./Ecommerce/badge.png": 1541,
	"./Ecommerce/barcode.png": 1542,
	"./Ecommerce/bedside-table.png": 1543,
	"./Ecommerce/billing-machine.png": 1544,
	"./Ecommerce/browser-1.png": 1545,
	"./Ecommerce/browser.png": 1546,
	"./Ecommerce/calculator.png": 1547,
	"./Ecommerce/cash-register.png": 1548,
	"./Ecommerce/click.png": 1549,
	"./Ecommerce/clock.png": 1550,
	"./Ecommerce/closed.png": 1551,
	"./Ecommerce/coin-1.png": 1552,
	"./Ecommerce/coin-stack.png": 1553,
	"./Ecommerce/coin.png": 1554,
	"./Ecommerce/comments.png": 1555,
	"./Ecommerce/compact-disc.png": 1556,
	"./Ecommerce/cosmetics.png": 1557,
	"./Ecommerce/coupon.png": 1558,
	"./Ecommerce/credit-card-1.png": 1559,
	"./Ecommerce/credit-card-2.png": 1560,
	"./Ecommerce/credit-card.png": 1561,
	"./Ecommerce/customer-service.png": 1562,
	"./Ecommerce/delivery-cart.png": 1563,
	"./Ecommerce/delivery-truck-1.png": 1564,
	"./Ecommerce/delivery-truck.png": 1565,
	"./Ecommerce/diamond.png": 1566,
	"./Ecommerce/discount.png": 1567,
	"./Ecommerce/email.png": 1568,
	"./Ecommerce/faq.png": 1569,
	"./Ecommerce/gift-card.png": 1570,
	"./Ecommerce/gift.png": 1571,
	"./Ecommerce/groceries.png": 1572,
	"./Ecommerce/help.png": 1573,
	"./Ecommerce/like.png": 1574,
	"./Ecommerce/money-bag.png": 1575,
	"./Ecommerce/money.png": 1576,
	"./Ecommerce/monitor.png": 1577,
	"./Ecommerce/news.png": 1578,
	"./Ecommerce/notepad.png": 1579,
	"./Ecommerce/online-shop-1.png": 1580,
	"./Ecommerce/online-shop-2.png": 1581,
	"./Ecommerce/online-shop-3.png": 1582,
	"./Ecommerce/online-shop.png": 1583,
	"./Ecommerce/open.png": 1584,
	"./Ecommerce/order.png": 1585,
	"./Ecommerce/package-1.png": 1586,
	"./Ecommerce/package-2.png": 1587,
	"./Ecommerce/package-3.png": 1588,
	"./Ecommerce/package.png": 1589,
	"./Ecommerce/padlock.png": 1590,
	"./Ecommerce/piggy-bank.png": 1591,
	"./Ecommerce/placeholder.png": 1592,
	"./Ecommerce/price-tag.png": 1593,
	"./Ecommerce/promotion.png": 1594,
	"./Ecommerce/purse.png": 1595,
	"./Ecommerce/qr-code.png": 1596,
	"./Ecommerce/receipt.png": 1597,
	"./Ecommerce/refund.png": 1598,
	"./Ecommerce/return.png": 1599,
	"./Ecommerce/review.png": 1600,
	"./Ecommerce/rocket-ship.png": 1601,
	"./Ecommerce/safebox.png": 1602,
	"./Ecommerce/search-1.png": 1603,
	"./Ecommerce/search.png": 1604,
	"./Ecommerce/shield.png": 1605,
	"./Ecommerce/shirt-1.png": 1606,
	"./Ecommerce/shirt.png": 1607,
	"./Ecommerce/shopping-bag-1.png": 1608,
	"./Ecommerce/shopping-bag-2.png": 1609,
	"./Ecommerce/shopping-bag.png": 1610,
	"./Ecommerce/shopping-basket-1.png": 1611,
	"./Ecommerce/shopping-basket-2.png": 1612,
	"./Ecommerce/shopping-basket-3.png": 1613,
	"./Ecommerce/shopping-basket-4.png": 1614,
	"./Ecommerce/shopping-basket.png": 1615,
	"./Ecommerce/shopping-cart-1.png": 1616,
	"./Ecommerce/shopping-cart-2.png": 1617,
	"./Ecommerce/shopping-cart-3.png": 1618,
	"./Ecommerce/shopping-cart-4.png": 1619,
	"./Ecommerce/shopping-cart.png": 1620,
	"./Ecommerce/smartphone-1.png": 1621,
	"./Ecommerce/smartphone.png": 1622,
	"./Ecommerce/star.png": 1623,
	"./Ecommerce/statistics.png": 1624,
	"./Ecommerce/stock-1.png": 1625,
	"./Ecommerce/stock-2.png": 1626,
	"./Ecommerce/stock.png": 1627,
	"./Ecommerce/stopwatch.png": 1628,
	"./Ecommerce/store.png": 1629,
	"./Ecommerce/survey.png": 1630,
	"./Ecommerce/user.png": 1631,
	"./Ecommerce/wallet.png": 1632,
	"./Ecommerce/wishlist-1.png": 1633,
	"./Ecommerce/wishlist.png": 1634,
	"./Ecommerce/worldwide.png": 1635,
	"./Emergencies/001-air-pump.png": 1636,
	"./Emergencies/002-helicopter.png": 1637,
	"./Emergencies/003-defibrillator.png": 1638,
	"./Emergencies/004-toolbox.png": 1639,
	"./Emergencies/005-smartphone.png": 1640,
	"./Emergencies/006-heart.png": 1641,
	"./Emergencies/007-hospital-2.png": 1642,
	"./Emergencies/008-tools.png": 1643,
	"./Emergencies/009-caution.png": 1644,
	"./Emergencies/010-hospital-1.png": 1645,
	"./Emergencies/011-pin.png": 1646,
	"./Emergencies/012-blood-transfusion.png": 1647,
	"./Emergencies/013-firefighter-1.png": 1648,
	"./Emergencies/014-barrier.png": 1649,
	"./Emergencies/015-fire-truck.png": 1650,
	"./Emergencies/016-police-badge.png": 1651,
	"./Emergencies/017-hospital.png": 1652,
	"./Emergencies/018-bucket.png": 1653,
	"./Emergencies/019-smoke-detector.png": 1654,
	"./Emergencies/020-shovel.png": 1655,
	"./Emergencies/021-walkie-talkie.png": 1656,
	"./Emergencies/022-firefighter.png": 1657,
	"./Emergencies/023-stretcher.png": 1658,
	"./Emergencies/024-lifebuoy.png": 1659,
	"./Emergencies/025-fire-extinguisher.png": 1660,
	"./Emergencies/026-warning.png": 1661,
	"./Emergencies/027-hydrant.png": 1662,
	"./Emergencies/028-matches.png": 1663,
	"./Emergencies/029-phone-call.png": 1664,
	"./Emergencies/030-life-jacket.png": 1665,
	"./Emergencies/031-band-aid.png": 1666,
	"./Emergencies/032-lighter.png": 1667,
	"./Emergencies/033-megaphone.png": 1668,
	"./Emergencies/034-sos.png": 1669,
	"./Emergencies/035-whistle.png": 1670,
	"./Emergencies/036-flashlight.png": 1671,
	"./Emergencies/037-sprinkler.png": 1672,
	"./Emergencies/038-fire-alarm-1.png": 1673,
	"./Emergencies/039-gas-mask.png": 1674,
	"./Emergencies/040-ambulance.png": 1675,
	"./Emergencies/041-emergency-call.png": 1676,
	"./Emergencies/042-first-aid-kit.png": 1677,
	"./Emergencies/043-fire.png": 1678,
	"./Emergencies/044-hose.png": 1679,
	"./Emergencies/045-exit.png": 1680,
	"./Emergencies/046-axe.png": 1681,
	"./Emergencies/047-cone.png": 1682,
	"./Emergencies/048-ladder.png": 1683,
	"./Emergencies/049-siren.png": 1684,
	"./Emergencies/050-fire-alarm.png": 1685,
	"./Family/001-couple-3.png": 1686,
	"./Family/002-house.png": 1687,
	"./Family/003-stroller.png": 1688,
	"./Family/004-son.png": 1689,
	"./Family/005-suitcase.png": 1690,
	"./Family/006-family-2.png": 1691,
	"./Family/007-pet-house.png": 1692,
	"./Family/008-cups.png": 1693,
	"./Family/009-photo-album.png": 1694,
	"./Family/010-fireplace.png": 1695,
	"./Family/011-pin.png": 1696,
	"./Family/012-insurance.png": 1697,
	"./Family/013-swing.png": 1698,
	"./Family/014-sofa.png": 1699,
	"./Family/015-couple-2.png": 1700,
	"./Family/016-home-1.png": 1701,
	"./Family/017-daughter.png": 1702,
	"./Family/018-gift-1.png": 1703,
	"./Family/019-shopping-basket.png": 1704,
	"./Family/020-television.png": 1705,
	"./Family/021-divorce.png": 1706,
	"./Family/022-picture-1.png": 1707,
	"./Family/023-briefcase.png": 1708,
	"./Family/024-graduate.png": 1709,
	"./Family/025-pacifier.png": 1710,
	"./Family/026-beach-ball.png": 1711,
	"./Family/027-love.png": 1712,
	"./Family/028-couple-1.png": 1713,
	"./Family/029-couple.png": 1714,
	"./Family/030-scooter.png": 1715,
	"./Family/031-gift.png": 1716,
	"./Family/032-picture.png": 1717,
	"./Family/033-wedding-rings.png": 1718,
	"./Family/034-wedding-cake.png": 1719,
	"./Family/035-newlyweds.png": 1720,
	"./Family/036-grave.png": 1721,
	"./Family/037-crib.png": 1722,
	"./Family/038-cat.png": 1723,
	"./Family/039-father.png": 1724,
	"./Family/040-dog.png": 1725,
	"./Family/041-care.png": 1726,
	"./Family/042-family-1.png": 1727,
	"./Family/043-grandparents.png": 1728,
	"./Family/044-family.png": 1729,
	"./Family/045-home.png": 1730,
	"./Family/046-motherhood.png": 1731,
	"./Family/047-grandfather.png": 1732,
	"./Family/048-grandmother.png": 1733,
	"./Family/049-newborn.png": 1734,
	"./Family/050-mother.png": 1735,
	"./GPS/compass-1.png": 1736,
	"./GPS/compass.png": 1737,
	"./GPS/gps.png": 1738,
	"./GPS/location-1.png": 1739,
	"./GPS/location-2.png": 1740,
	"./GPS/location-3.png": 1741,
	"./GPS/location.png": 157,
	"./GPS/location3.png": 1742,
	"./GPS/location_green.svg": 293,
	"./GPS/locations.png": 1743,
	"./GPS/map-1.png": 1744,
	"./GPS/map-2.png": 1745,
	"./GPS/map-3.png": 1746,
	"./GPS/map.png": 1747,
	"./GPS/navigator.png": 1748,
	"./GPS/panel.png": 1749,
	"./GPS/pin.png": 1750,
	"./GPS/placeholder-1.png": 1751,
	"./GPS/placeholder-2.png": 1752,
	"./GPS/placeholder-3.png": 1753,
	"./GPS/placeholder-4.png": 1754,
	"./GPS/placeholder-5.png": 1755,
	"./GPS/placeholder-6.png": 1756,
	"./GPS/placeholder-7.png": 1757,
	"./GPS/placeholder.png": 114,
	"./GPS/push-pin.png": 1758,
	"./GPS/route-1.png": 1759,
	"./GPS/route.png": 1760,
	"./GPS/satellite.png": 1761,
	"./GPS/selectLocation.svg": 141,
	"./GPS/smartphone-1.png": 1762,
	"./GPS/smartphone.png": 1763,
	"./GPS/target.png": 1764,
	"./Home/alarm-clock.png": 1765,
	"./Home/alcoholic-1.png": 1766,
	"./Home/alcoholic.png": 1767,
	"./Home/bake.png": 1768,
	"./Home/bathing.png": 1769,
	"./Home/bedroom-1.png": 1770,
	"./Home/bedroom-2.png": 1771,
	"./Home/bedroom-3.png": 1772,
	"./Home/bedroom-4.png": 1773,
	"./Home/bedroom-5.png": 1774,
	"./Home/bedroom-6.png": 1775,
	"./Home/bedroom.png": 1776,
	"./Home/bookcase.png": 1777,
	"./Home/carpenter.png": 1778,
	"./Home/carpet.png": 1779,
	"./Home/chairs-1.png": 1780,
	"./Home/chairs-2.png": 1781,
	"./Home/chairs.png": 1782,
	"./Home/chinese-food.png": 1783,
	"./Home/coffee-cup-1.png": 1784,
	"./Home/coffee-cup-2.png": 1785,
	"./Home/coffee-shop.png": 1786,
	"./Home/coffees.png": 1787,
	"./Home/comfortable-1.png": 1788,
	"./Home/comfortable.png": 1789,
	"./Home/coolnes.png": 1790,
	"./Home/couch.png": 1791,
	"./Home/door-key.png": 1792,
	"./Home/drinking.png": 1793,
	"./Home/elegant.png": 1794,
	"./Home/firefighting.png": 1795,
	"./Home/fry.png": 1796,
	"./Home/game-console.png": 1797,
	"./Home/garbage-bin.png": 1798,
	"./Home/gardening.png": 1799,
	"./Home/hair-salon.png": 1800,
	"./Home/hangers.png": 1801,
	"./Home/home-repair.png": 1802,
	"./Home/hot-drink.png": 1803,
	"./Home/hygienic-1.png": 1804,
	"./Home/hygienic.png": 1805,
	"./Home/invention.png": 1806,
	"./Home/japanese-food.png": 1807,
	"./Home/kitchen-pack-1.png": 1808,
	"./Home/kitchen-pack-10.png": 1809,
	"./Home/kitchen-pack-11.png": 1810,
	"./Home/kitchen-pack-12.png": 1811,
	"./Home/kitchen-pack-13.png": 1812,
	"./Home/kitchen-pack-14.png": 1813,
	"./Home/kitchen-pack-15.png": 1814,
	"./Home/kitchen-pack-16.png": 1815,
	"./Home/kitchen-pack-2.png": 1816,
	"./Home/kitchen-pack-3.png": 1817,
	"./Home/kitchen-pack-4.png": 1818,
	"./Home/kitchen-pack-5.png": 1819,
	"./Home/kitchen-pack-6.png": 1820,
	"./Home/kitchen-pack-7.png": 1821,
	"./Home/kitchen-pack-8.png": 1822,
	"./Home/kitchen-pack-9.png": 1823,
	"./Home/kitchen-pack.png": 1824,
	"./Home/kitchen-tools.png": 1825,
	"./Home/laptop-computer.png": 1826,
	"./Home/livingroom-1.png": 1827,
	"./Home/livingroom-2.png": 1828,
	"./Home/livingroom.png": 1829,
	"./Home/passkey.png": 1830,
	"./Home/phone-call.png": 1831,
	"./Home/phone-receiver.png": 1832,
	"./Home/plugging-1.png": 1833,
	"./Home/plugging.png": 1834,
	"./Home/protein.png": 1835,
	"./Home/real-estate-1.png": 1836,
	"./Home/real-estate-2.png": 1837,
	"./Home/real-estate-3.png": 1838,
	"./Home/real-estate.png": 1839,
	"./Home/reflecting.png": 1840,
	"./Home/refreshment.png": 1841,
	"./Home/restauran.png": 1842,
	"./Home/restroom.png": 1843,
	"./Home/seat.png": 1844,
	"./Home/seatting.png": 1845,
	"./Home/showers.png": 1846,
	"./Home/sinks.png": 1847,
	"./Home/sleepy.png": 1848,
	"./Home/studying-1.png": 1849,
	"./Home/studying-2.png": 1850,
	"./Home/studying.png": 1851,
	"./Home/supper.png": 1852,
	"./Home/technological.png": 1853,
	"./Home/televisions-1.png": 1854,
	"./Home/televisions.png": 1855,
	"./Home/ventilator.png": 1856,
	"./Home/wooden-chair.png": 1857,
	"./Home/yard.png": 1858,
	"./Hospital/ambulance.png": 1859,
	"./Hospital/band-aid.png": 1860,
	"./Hospital/bandage.png": 1861,
	"./Hospital/blood-donation.png": 1862,
	"./Hospital/blood-sample.png": 1863,
	"./Hospital/blood-transfusion.png": 1864,
	"./Hospital/broken-bone.png": 1865,
	"./Hospital/cardiogram.png": 1866,
	"./Hospital/clinic-history.png": 1867,
	"./Hospital/coffee-cup.png": 1868,
	"./Hospital/crutches.png": 1869,
	"./Hospital/dna.png": 1870,
	"./Hospital/doctor.png": 1871,
	"./Hospital/dropper.png": 1872,
	"./Hospital/electrocardiogram.png": 1873,
	"./Hospital/eye-drops.png": 1874,
	"./Hospital/eye.png": 1875,
	"./Hospital/first-aid-kit.png": 1876,
	"./Hospital/flask.png": 1877,
	"./Hospital/hospital-1.png": 1878,
	"./Hospital/hospital-2.png": 1879,
	"./Hospital/hospital-bed.png": 1880,
	"./Hospital/hospital.png": 1881,
	"./Hospital/id-card.png": 1882,
	"./Hospital/laptop.png": 1883,
	"./Hospital/mask.png": 1884,
	"./Hospital/medicine-1.png": 1885,
	"./Hospital/medicine-2.png": 1886,
	"./Hospital/medicine-3.png": 1887,
	"./Hospital/medicine-4.png": 1888,
	"./Hospital/medicine.png": 1889,
	"./Hospital/microscope.png": 1890,
	"./Hospital/nurse.png": 1891,
	"./Hospital/optometry.png": 1892,
	"./Hospital/pill.png": 1893,
	"./Hospital/pills-1.png": 1894,
	"./Hospital/pills.png": 1895,
	"./Hospital/placeholder.png": 1896,
	"./Hospital/prescription.png": 1897,
	"./Hospital/serum.png": 1898,
	"./Hospital/shirt.png": 1899,
	"./Hospital/smartphone.png": 1900,
	"./Hospital/stethoscope.png": 1901,
	"./Hospital/tag.png": 1902,
	"./Hospital/test-tube.png": 1903,
	"./Hospital/thermometer.png": 1904,
	"./Hospital/tooth.png": 1905,
	"./Hospital/vaccine.png": 1906,
	"./Hospital/virus.png": 1907,
	"./Hospital/weight.png": 1908,
	"./Lights/amber_light.png": 1909,
	"./Lights/green_light.png": 1910,
	"./Lights/grey_light.png": 1911,
	"./Lights/red_light.png": 1912,
	"./Lights/traffic_light_green.png": 1913,
	"./Lights/traffic_light_none.png": 1914,
	"./Lights/traffic_light_red.png": 1915,
	"./Lights/trafficlight.png": 1916,
	"./Lights/trafficlightcolour.png": 1917,
	"./Logistics/001-distribution-5.png": 1918,
	"./Logistics/002-aerial.png": 1919,
	"./Logistics/003-frontal-view.png": 1920,
	"./Logistics/004-distribution-4.png": 1921,
	"./Logistics/005-clipboards.png": 1922,
	"./Logistics/006-oceanic.png": 1923,
	"./Logistics/007-placeholders-1.png": 1924,
	"./Logistics/008-international.png": 1925,
	"./Logistics/009-packages-2.png": 1926,
	"./Logistics/010-tools-and-utensils-3.png": 1927,
	"./Logistics/011-weekly-calendar.png": 1928,
	"./Logistics/012-placeholders.png": 1929,
	"./Logistics/013-distribution-3.png": 1930,
	"./Logistics/014-shopping-carts-1.png": 1931,
	"./Logistics/015-maps-and-flags-1.png": 1932,
	"./Logistics/016-organizing.png": 1933,
	"./Logistics/017-maps-and-flags.png": 1934,
	"./Logistics/018-tools-and-utensils-2.png": 1935,
	"./Logistics/019-call-center-1.png": 1936,
	"./Logistics/020-protected.png": 1937,
	"./Logistics/021-cubes.png": 1938,
	"./Logistics/022-distribution-2.png": 1939,
	"./Logistics/023-call-center.png": 1940,
	"./Logistics/024-bussiness.png": 1941,
	"./Logistics/025-charter.png": 1942,
	"./Logistics/026-trolley-cart.png": 1943,
	"./Logistics/027-distribution-1.png": 1944,
	"./Logistics/028-tools-and-utensils-1.png": 1945,
	"./Logistics/029-airplanes.png": 1946,
	"./Logistics/030-verified.png": 1947,
	"./Logistics/031-shopping-carts.png": 1948,
	"./Logistics/032-transportation.png": 1949,
	"./Logistics/033-packages-1.png": 1950,
	"./Logistics/034-changing.png": 1951,
	"./Logistics/035-packages.png": 1952,
	"./Logistics/036-symbolic.png": 1953,
	"./Logistics/037-packing.png": 1954,
	"./Logistics/038-trucks.png": 1955,
	"./Logistics/039-tools-and-utensils.png": 1956,
	"./Logistics/040-circular-arrows.png": 1957,
	"./Logistics/041-debit-card.png": 1958,
	"./Logistics/042-24-hours.png": 1959,
	"./Logistics/043-distribution.png": 1960,
	"./Logistics/044-cargo-ship.png": 1961,
	"./Machinery/BackhoeLoader_Black.png": 1962,
	"./Machinery/BackhoeLoader_Blue.png": 1963,
	"./Machinery/BackhoeLoader_Green.png": 1964,
	"./Machinery/BackhoeLoader_Grey.png": 1965,
	"./Machinery/BackhoeLoader_Red.png": 1966,
	"./Machinery/BackhoeLoader_Yellow.png": 1967,
	"./Machinery/Bulldozer_Black.png": 1968,
	"./Machinery/Bulldozer_Blue.png": 1969,
	"./Machinery/Bulldozer_Green.png": 1970,
	"./Machinery/Bulldozer_Grey.png": 1971,
	"./Machinery/Bulldozer_Red.png": 1972,
	"./Machinery/Bulldozer_Yellow.png": 1973,
	"./Machinery/CompactExcavator_Black.png": 1974,
	"./Machinery/CompactExcavator_Blue.png": 1975,
	"./Machinery/CompactExcavator_Green.png": 1976,
	"./Machinery/CompactExcavator_Grey.png": 1977,
	"./Machinery/CompactExcavator_Red.png": 1978,
	"./Machinery/CompactExcavator_Yellow.png": 1979,
	"./Machinery/Excavator_Black.png": 1980,
	"./Machinery/Excavator_Blue.png": 1981,
	"./Machinery/Excavator_Green.png": 1982,
	"./Machinery/Excavator_Grey.png": 1983,
	"./Machinery/Excavator_Red.png": 1984,
	"./Machinery/Excavator_Yellow.png": 1985,
	"./Machinery/FarmTractor_Black.png": 1986,
	"./Machinery/FarmTractor_Blue.png": 1987,
	"./Machinery/FarmTractor_Green.png": 1988,
	"./Machinery/FarmTractor_Grey.png": 1989,
	"./Machinery/FarmTractor_Red.png": 1990,
	"./Machinery/FarmTractor_Yellow.png": 1991,
	"./Machinery/ForkliftTruck_Loaded_Black.png": 1992,
	"./Machinery/ForkliftTruck_Loaded_Blue.png": 1993,
	"./Machinery/ForkliftTruck_Loaded_Green.png": 1994,
	"./Machinery/ForkliftTruck_Loaded_Grey.png": 1995,
	"./Machinery/ForkliftTruck_Loaded_Red.png": 1996,
	"./Machinery/ForkliftTruck_Loaded_Yellow.png": 1997,
	"./Machinery/ForkliftTruck__Black.png": 1998,
	"./Machinery/ForkliftTruck__Blue.png": 1999,
	"./Machinery/ForkliftTruck__Green.png": 2000,
	"./Machinery/ForkliftTruck__Grey.png": 2001,
	"./Machinery/ForkliftTruck__Red.png": 2002,
	"./Machinery/ForkliftTruck__Yellow.png": 2003,
	"./Machinery/LandfillCompactor_Black.png": 2004,
	"./Machinery/LandfillCompactor_Blue.png": 2005,
	"./Machinery/LandfillCompactor_Green.png": 2006,
	"./Machinery/LandfillCompactor_Grey.png": 2007,
	"./Machinery/LandfillCompactor_Red.png": 2008,
	"./Machinery/LandfillCompactor_Yellow.png": 2009,
	"./Machinery/Loader_Black.png": 2010,
	"./Machinery/Loader_Blue.png": 2011,
	"./Machinery/Loader_Green.png": 2012,
	"./Machinery/Loader_Grey.png": 2013,
	"./Machinery/Loader_Red.png": 2014,
	"./Machinery/Loader_Yellow.png": 2015,
	"./Machinery/MaterialHandler_Black.png": 2016,
	"./Machinery/MaterialHandler_Blue.png": 2017,
	"./Machinery/MaterialHandler_Green.png": 2018,
	"./Machinery/MaterialHandler_Grey.png": 2019,
	"./Machinery/MaterialHandler_Red.png": 2020,
	"./Machinery/MaterialHandler_Yellow.png": 2021,
	"./Machinery/RoadRoller_Black.png": 2022,
	"./Machinery/RoadRoller_Blue.png": 2023,
	"./Machinery/RoadRoller_Green.png": 2024,
	"./Machinery/RoadRoller_Grey.png": 2025,
	"./Machinery/RoadRoller_Red.png": 2026,
	"./Machinery/RoadRoller_Yellow.png": 2027,
	"./Machinery/RoadSweeper_Black.png": 2028,
	"./Machinery/RoadSweeper_Blue.png": 2029,
	"./Machinery/RoadSweeper_Green.png": 2030,
	"./Machinery/RoadSweeper_Grey.png": 2031,
	"./Machinery/RoadSweeper_Red.png": 2032,
	"./Machinery/RoadSweeper_Yellow.png": 2033,
	"./Machinery/RollerCompactor_Black.png": 2034,
	"./Machinery/RollerCompactor_Blue.png": 2035,
	"./Machinery/RollerCompactor_Green.png": 2036,
	"./Machinery/RollerCompactor_Grey.png": 2037,
	"./Machinery/RollerCompactor_Red.png": 2038,
	"./Machinery/RollerCompactor_Yellow.png": 2039,
	"./Machinery/SkidSteerLoader_Black.png": 2040,
	"./Machinery/SkidSteerLoader_Blue.png": 2041,
	"./Machinery/SkidSteerLoader_Green.png": 2042,
	"./Machinery/SkidSteerLoader_Grey.png": 2043,
	"./Machinery/SkidSteerLoader_Red.png": 2044,
	"./Machinery/SkidSteerLoader_Yellow.png": 2045,
	"./Machinery/SkipLoader_Black.png": 2046,
	"./Machinery/SkipLoader_Blue.png": 2047,
	"./Machinery/SkipLoader_Green.png": 2048,
	"./Machinery/SkipLoader_Grey.png": 2049,
	"./Machinery/SkipLoader_Red.png": 2050,
	"./Machinery/SkipLoader_Yellow.png": 2051,
	"./Machinery/SoilStabilizer_Black.png": 2052,
	"./Machinery/SoilStabilizer_Blue.png": 2053,
	"./Machinery/SoilStabilizer_Green.png": 2054,
	"./Machinery/SoilStabilizer_Grey.png": 2055,
	"./Machinery/SoilStabilizer_Red.png": 2056,
	"./Machinery/SoilStabilizer_Yellow.png": 2057,
	"./Machinery/SteamRoller_Black.png": 2058,
	"./Machinery/SteamRoller_Blue.png": 2059,
	"./Machinery/SteamRoller_Green.png": 2060,
	"./Machinery/SteamRoller_Grey.png": 2061,
	"./Machinery/SteamRoller_Red.png": 2062,
	"./Machinery/SteamRoller_Yellow.png": 2063,
	"./Machinery/StreetSweeper_Black.png": 2064,
	"./Machinery/StreetSweeper_Blue.png": 2065,
	"./Machinery/StreetSweeper_Green.png": 2066,
	"./Machinery/StreetSweeper_Grey.png": 2067,
	"./Machinery/StreetSweeper_Red.png": 2068,
	"./Machinery/StreetSweeper_Yellow.png": 2069,
	"./Machinery/TelescopicHandler_Black.png": 2070,
	"./Machinery/TelescopicHandler_Blue.png": 2071,
	"./Machinery/TelescopicHandler_Green.png": 2072,
	"./Machinery/TelescopicHandler_Grey.png": 2073,
	"./Machinery/TelescopicHandler_Red.png": 2074,
	"./Machinery/TelescopicHandler_Yellow.png": 2075,
	"./Machinery/TruckMountedCrane_Working_Black.png": 2076,
	"./Machinery/TruckMountedCrane_Working_Blue.png": 2077,
	"./Machinery/TruckMountedCrane_Working_Green.png": 2078,
	"./Machinery/TruckMountedCrane_Working_Grey.png": 2079,
	"./Machinery/TruckMountedCrane_Working_Red.png": 2080,
	"./Machinery/TruckMountedCrane_Working_Yellow.png": 2081,
	"./Machinery/TruckMountedCrane__Black.png": 2082,
	"./Machinery/TruckMountedCrane__Blue.png": 2083,
	"./Machinery/TruckMountedCrane__Green.png": 2084,
	"./Machinery/TruckMountedCrane__Grey.png": 2085,
	"./Machinery/TruckMountedCrane__Red.png": 2086,
	"./Machinery/TruckMountedCrane__Yellow.png": 2087,
	"./Machinery/WheeledExcavator_Black.png": 2088,
	"./Machinery/WheeledExcavator_Blue.png": 2089,
	"./Machinery/WheeledExcavator_Green.png": 2090,
	"./Machinery/WheeledExcavator_Grey.png": 2091,
	"./Machinery/WheeledExcavator_Red.png": 2092,
	"./Machinery/WheeledExcavator_Yellow.png": 2093,
	"./Machinery/WreckingBall_Black.png": 2094,
	"./Machinery/WreckingBall_Blue.png": 2095,
	"./Machinery/WreckingBall_Green.png": 2096,
	"./Machinery/WreckingBall_Grey.png": 2097,
	"./Machinery/WreckingBall_Red.png": 2098,
	"./Machinery/WreckingBall_Yellow.png": 2099,
	"./Marine/001-pirate-3.png": 2100,
	"./Marine/001-whale.png": 2101,
	"./Marine/002-hook.png": 2102,
	"./Marine/002-lifesaver.png": 2103,
	"./Marine/003-round-shot.png": 2104,
	"./Marine/003-sailor-cap-2.png": 2105,
	"./Marine/004-anchor-2.png": 2106,
	"./Marine/004-starfish.png": 2107,
	"./Marine/005-anchor-1.png": 2108,
	"./Marine/005-cannon.png": 2109,
	"./Marine/006-dolphin.png": 2110,
	"./Marine/006-parrot.png": 2111,
	"./Marine/007-island.png": 2112,
	"./Marine/007-knot-1.png": 2113,
	"./Marine/008-pirate-2.png": 2114,
	"./Marine/008-sailor-cap-1.png": 2115,
	"./Marine/009-flag.png": 2116,
	"./Marine/009-key.png": 2117,
	"./Marine/010-barrel.png": 2118,
	"./Marine/010-seagull-1.png": 2119,
	"./Marine/011-boat.png": 2120,
	"./Marine/011-paddle.png": 2121,
	"./Marine/012-pirate-ship.png": 2122,
	"./Marine/012-porthole.png": 2123,
	"./Marine/013-bollard.png": 2124,
	"./Marine/013-gold-ingots.png": 2125,
	"./Marine/014-lighthouse-1.png": 2126,
	"./Marine/014-placeholder.png": 2127,
	"./Marine/015-buoys.png": 2128,
	"./Marine/015-skull-and-bones.png": 2129,
	"./Marine/016-flippers.png": 2130,
	"./Marine/016-sword.png": 2131,
	"./Marine/017-pirate-1.png": 2132,
	"./Marine/017-shirt.png": 2133,
	"./Marine/018-chains.png": 2134,
	"./Marine/018-pipe.png": 2135,
	"./Marine/019-eyepatch.png": 2136,
	"./Marine/019-pipe-1.png": 2137,
	"./Marine/020-compass-2.png": 2138,
	"./Marine/020-gallows.png": 2139,
	"./Marine/021-coin.png": 2140,
	"./Marine/021-radar-1.png": 2141,
	"./Marine/022-compass-1.png": 2142,
	"./Marine/022-rum.png": 2143,
	"./Marine/023-money-bag.png": 2144,
	"./Marine/023-radar.png": 2145,
	"./Marine/024-diving-helmet.png": 2146,
	"./Marine/024-pirate.png": 2147,
	"./Marine/025-bottle.png": 2148,
	"./Marine/025-treasure-map.png": 2149,
	"./Marine/026-captain.png": 2150,
	"./Marine/026-wooden-leg.png": 2151,
	"./Marine/027-helm.png": 2152,
	"./Marine/027-yatch.png": 2153,
	"./Marine/028-message-in-a-bottle.png": 2154,
	"./Marine/028-oars.png": 2155,
	"./Marine/029-lighthouse.png": 2156,
	"./Marine/029-ship.png": 2157,
	"./Marine/030-binoculars.png": 2158,
	"./Marine/030-torch.png": 2159,
	"./Marine/031-jolly-roger.png": 2160,
	"./Marine/031-propeller.png": 2161,
	"./Marine/032-bell.png": 2162,
	"./Marine/032-hook.png": 2163,
	"./Marine/033-dice.png": 2164,
	"./Marine/033-map.png": 2165,
	"./Marine/034-sailor-cap.png": 2166,
	"./Marine/034-telescope.png": 2167,
	"./Marine/035-knot.png": 2168,
	"./Marine/035-tortoise.png": 2169,
	"./Marine/036-letter.png": 2170,
	"./Marine/036-waves.png": 2171,
	"./Marine/037-anchor.png": 2172,
	"./Marine/037-pipe.png": 2173,
	"./Marine/038-compass.png": 2174,
	"./Marine/038-lifebuoy.png": 2175,
	"./Marine/039-bomb.png": 2176,
	"./Marine/039-rudder-1.png": 2177,
	"./Marine/040-sailboat.png": 2178,
	"./Marine/040-treasure.png": 2179,
	"./Marine/041-starfish.png": 2180,
	"./Marine/042-lighthouse.png": 2181,
	"./Marine/043-spyglass.png": 2182,
	"./Marine/044-fish.png": 2183,
	"./Marine/045-compass.png": 2184,
	"./Marine/046-anchor.png": 2185,
	"./Marine/047-seagull.png": 2186,
	"./Marine/048-rudder.png": 2187,
	"./Marine/049-snorkel.png": 2188,
	"./Marine/050-life-jacket.png": 2189,
	"./Military/001-knife.png": 2190,
	"./Military/002-bomb-1.png": 2191,
	"./Military/003-radar.png": 2192,
	"./Military/004-medal-1.png": 2193,
	"./Military/005-launcher-1.png": 2194,
	"./Military/006-helmet.png": 2195,
	"./Military/007-chamber.png": 2196,
	"./Military/008-helicopter.png": 2197,
	"./Military/009-soldier.png": 2198,
	"./Military/010-lieutenant.png": 2199,
	"./Military/011-shotgun.png": 2200,
	"./Military/012-backpack.png": 2201,
	"./Military/013-bomb-detonation-1.png": 2202,
	"./Military/014-bomb-detonation.png": 2203,
	"./Military/015-fighter-plane.png": 2204,
	"./Military/016-dynamite.png": 2205,
	"./Military/017-first-aid-kit-1.png": 2206,
	"./Military/018-boat.png": 2207,
	"./Military/019-submarine.png": 2208,
	"./Military/020-compass.png": 2209,
	"./Military/021-insignia.png": 2210,
	"./Military/022-first-aid-kit.png": 2211,
	"./Military/023-placeholder.png": 2212,
	"./Military/024-jet.png": 2213,
	"./Military/025-flag.png": 2214,
	"./Military/026-boots.png": 2215,
	"./Military/027-gas-mask.png": 2216,
	"./Military/028-bullet-1.png": 2217,
	"./Military/029-launcher.png": 2218,
	"./Military/030-satellite-dish.png": 2219,
	"./Military/031-parachute.png": 2220,
	"./Military/032-gun.png": 2221,
	"./Military/033-bulletproof.png": 2222,
	"./Military/034-swiss-army-knife.png": 2223,
	"./Military/035-bullet.png": 2224,
	"./Military/036-binoculars.png": 2225,
	"./Military/037-target.png": 2226,
	"./Military/038-walkie-talkie.png": 2227,
	"./Military/039-rank.png": 2228,
	"./Military/040-barbed.png": 2229,
	"./Military/041-bomb.png": 2230,
	"./Military/042-radiation.png": 2231,
	"./Military/043-chevron.png": 2232,
	"./Military/044-map.png": 2233,
	"./Military/045-medal.png": 2234,
	"./Military/046-tank.png": 2235,
	"./Military/047-tent.png": 2236,
	"./Military/048-dog-tags-military.png": 2237,
	"./Military/049-grenade.png": 2238,
	"./Military/050-badge.png": 2239,
	"./Multimedia/3d-glasses.png": 2240,
	"./Multimedia/antenna.png": 2241,
	"./Multimedia/camera-1.png": 2242,
	"./Multimedia/camera-2.png": 2243,
	"./Multimedia/camera-3.png": 2244,
	"./Multimedia/camera.png": 2245,
	"./Multimedia/cd.png": 2246,
	"./Multimedia/chat.png": 2247,
	"./Multimedia/clapperboard.png": 2248,
	"./Multimedia/cloud.png": 2249,
	"./Multimedia/compact-disc.png": 2250,
	"./Multimedia/dvd.png": 2251,
	"./Multimedia/equalizer.png": 2252,
	"./Multimedia/film.png": 2253,
	"./Multimedia/floppy-disk.png": 2254,
	"./Multimedia/game.png": 2255,
	"./Multimedia/ipod-shuffle.png": 2256,
	"./Multimedia/ipod.png": 2257,
	"./Multimedia/keyboard.png": 2258,
	"./Multimedia/loudspeaker-1.png": 2259,
	"./Multimedia/loudspeaker.png": 2260,
	"./Multimedia/memory-card.png": 2261,
	"./Multimedia/microphone-1.png": 2262,
	"./Multimedia/microphone.png": 2263,
	"./Multimedia/mobile-phone.png": 2264,
	"./Multimedia/modem.png": 2265,
	"./Multimedia/negative-film.png": 2266,
	"./Multimedia/negative.png": 2267,
	"./Multimedia/next-track.png": 2268,
	"./Multimedia/pause.png": 2269,
	"./Multimedia/photos.png": 2270,
	"./Multimedia/play.png": 2271,
	"./Multimedia/previous-track.png": 2272,
	"./Multimedia/radio.png": 2273,
	"./Multimedia/rec.png": 2274,
	"./Multimedia/speaker.png": 2275,
	"./Multimedia/stop.png": 2276,
	"./Multimedia/tablet.png": 2277,
	"./Multimedia/tv-1.png": 2278,
	"./Multimedia/tv.png": 2279,
	"./Multimedia/web-cam.png": 2280,
	"./Office/adhesive-tape.png": 2281,
	"./Office/bookshelf.png": 2282,
	"./Office/box.png": 2283,
	"./Office/briefcase.png": 2284,
	"./Office/business-card.png": 2285,
	"./Office/cabinet.png": 2286,
	"./Office/calculator.png": 2287,
	"./Office/calendar.png": 2288,
	"./Office/clipboard.png": 2289,
	"./Office/clock.png": 2290,
	"./Office/coffee-cup.png": 2291,
	"./Office/computer.png": 2292,
	"./Office/copy-machine.png": 2293,
	"./Office/documents.png": 2294,
	"./Office/fax.png": 2295,
	"./Office/folder-1.png": 2296,
	"./Office/folder-2.png": 2297,
	"./Office/folder.png": 2298,
	"./Office/garbage.png": 2299,
	"./Office/headphones.png": 2300,
	"./Office/highlighter.png": 2301,
	"./Office/hole-puncher.png": 2302,
	"./Office/id-card.png": 2303,
	"./Office/lamp.png": 2304,
	"./Office/laptop.png": 2305,
	"./Office/letters.png": 2306,
	"./Office/mail.png": 2307,
	"./Office/mouse.png": 2308,
	"./Office/mug.png": 2309,
	"./Office/note.png": 2310,
	"./Office/notebook-1.png": 2311,
	"./Office/notebook.png": 2312,
	"./Office/office-chair.png": 2313,
	"./Office/paper-shredder.png": 2314,
	"./Office/pen.png": 2315,
	"./Office/pencil-case.png": 2316,
	"./Office/pendrive.png": 2317,
	"./Office/plant.png": 2318,
	"./Office/presentation.png": 2319,
	"./Office/printer.png": 2320,
	"./Office/projector.png": 2321,
	"./Office/push-pin.png": 2322,
	"./Office/router.png": 2323,
	"./Office/rubber-stamp.png": 2324,
	"./Office/safebox.png": 2325,
	"./Office/stapler.png": 2326,
	"./Office/table.png": 2327,
	"./Office/telephone.png": 2328,
	"./Office/uniform.png": 2329,
	"./Office/webcam.png": 2330,
	"./Professions/astronaut.png": 2331,
	"./Professions/athlete.png": 2332,
	"./Professions/builder.png": 2333,
	"./Professions/carpenter.png": 2334,
	"./Professions/cashier.png": 2335,
	"./Professions/chef.png": 2336,
	"./Professions/chemist.png": 2337,
	"./Professions/clown.png": 2338,
	"./Professions/concierge.png": 2339,
	"./Professions/courier.png": 2340,
	"./Professions/detective.png": 2341,
	"./Professions/diver.png": 2342,
	"./Professions/dj.png": 2343,
	"./Professions/doctor.png": 2344,
	"./Professions/dyer.png": 2345,
	"./Professions/electrician.png": 2346,
	"./Professions/farmer.png": 2347,
	"./Professions/firefighter.png": 2348,
	"./Professions/fisherman.png": 2349,
	"./Professions/gardener.png": 2350,
	"./Professions/hairdresser.png": 2351,
	"./Professions/lumberjack.png": 2352,
	"./Professions/magician.png": 2353,
	"./Professions/maid.png": 2354,
	"./Professions/manager.png": 2355,
	"./Professions/mechanic.png": 2356,
	"./Professions/miner.png": 2357,
	"./Professions/nurse.png": 2358,
	"./Professions/painter.png": 2359,
	"./Professions/pensioner.png": 2360,
	"./Professions/personplaceholder.png": 385,
	"./Professions/photographer.png": 2361,
	"./Professions/pilot.png": 2362,
	"./Professions/plumber.png": 2363,
	"./Professions/policeman.png": 2364,
	"./Professions/politician.png": 2365,
	"./Professions/postman.png": 2366,
	"./Professions/priest.png": 2367,
	"./Professions/professor.png": 2368,
	"./Professions/programmer.png": 2369,
	"./Professions/sailor.png": 2370,
	"./Professions/secretary.png": 2371,
	"./Professions/showman.png": 2372,
	"./Professions/singer.png": 2373,
	"./Professions/soldier.png": 2374,
	"./Professions/stewardess.png": 2375,
	"./Professions/support.png": 2376,
	"./Professions/taxi-driver.png": 2377,
	"./Professions/teacher.png": 2378,
	"./Professions/waiter.png": 2379,
	"./Professions/writer.png": 2380,
	"./PublicTransport/Coach_Black.png": 2381,
	"./PublicTransport/Coach_Blue.png": 2382,
	"./PublicTransport/Coach_Green.png": 2383,
	"./PublicTransport/Coach_Grey.png": 2384,
	"./PublicTransport/Coach_Red.png": 2385,
	"./PublicTransport/Coach_Yellow.png": 2386,
	"./PublicTransport/CommuterBus_Black.png": 2387,
	"./PublicTransport/CommuterBus_Blue.png": 2388,
	"./PublicTransport/CommuterBus_Green.png": 2389,
	"./PublicTransport/CommuterBus_Grey.png": 2390,
	"./PublicTransport/CommuterBus_Red.png": 2391,
	"./PublicTransport/CommuterBus_Yellow.png": 2392,
	"./PublicTransport/Taxi_Black.png": 2393,
	"./PublicTransport/Taxi_Blue.png": 2394,
	"./PublicTransport/Taxi_Green.png": 2395,
	"./PublicTransport/Taxi_Grey.png": 2396,
	"./PublicTransport/Taxi_Red.png": 2397,
	"./PublicTransport/Taxi_Yellow.png": 2398,
	"./PublicTransport/TransitBus_Black.png": 2399,
	"./PublicTransport/TransitBus_Blue.png": 2400,
	"./PublicTransport/TransitBus_Green.png": 2401,
	"./PublicTransport/TransitBus_Grey.png": 2402,
	"./PublicTransport/TransitBus_Red.png": 2403,
	"./PublicTransport/TransitBus_Yellow.png": 2404,
	"./Safety/001-fire.png": 2405,
	"./Safety/002-umbrella.png": 2406,
	"./Safety/003-shield-1.png": 2407,
	"./Safety/004-lifebuoy.png": 2408,
	"./Safety/005-cone.png": 2409,
	"./Safety/006-eye.png": 2410,
	"./Safety/007-helmet.png": 2411,
	"./Safety/008-safety-belt.png": 2412,
	"./Safety/009-first-aid-kit.png": 2413,
	"./Safety/010-barbed-wire.png": 2414,
	"./Safety/011-shield.png": 2415,
	"./Safety/012-cctv-1.png": 2416,
	"./Safety/013-cctv.png": 2417,
	"./Safety/014-fire-alarm-1.png": 2418,
	"./Safety/015-hose.png": 2419,
	"./Safety/016-hydrant.png": 2420,
	"./Safety/017-flasher.png": 2421,
	"./Safety/018-kitchen-hood.png": 2422,
	"./Safety/019-air-compressor.png": 2423,
	"./Safety/020-gas-mask.png": 2424,
	"./Safety/021-carbon-monoxide.png": 2425,
	"./Safety/022-extinguisher.png": 2426,
	"./Safety/023-sprinkler.png": 2427,
	"./Safety/024-pull.png": 2428,
	"./Safety/025-fire-alarm.png": 2429,
	"./Safety/026-smoke-detector.png": 2430,
	"./Safety/027-safety-code.png": 2431,
	"./Safety/028-signal.png": 2432,
	"./Safety/029-strongbox.png": 2433,
	"./Safety/030-password.png": 2434,
	"./Safety/031-key.png": 2435,
	"./Safety/032-keyhole.png": 2436,
	"./Safety/033-exit-1.png": 2437,
	"./Safety/034-door.png": 2438,
	"./Safety/035-padlock-1.png": 2439,
	"./Safety/036-padlock.png": 2440,
	"./Safety/037-house.png": 2441,
	"./Safety/038-exit.png": 2442,
	"./Safety/039-bell.png": 2443,
	"./Safety/040-stop.png": 2444,
	"./Safety/041-radiation.png": 2445,
	"./Safety/042-forbidden.png": 2446,
	"./Safety/043-not-touch.png": 2447,
	"./Safety/044-no-smoking.png": 2448,
	"./Safety/045-no-fire.png": 2449,
	"./Safety/046-high-voltage.png": 2450,
	"./Safety/047-fire-sign.png": 2451,
	"./Safety/048-warning.png": 2452,
	"./Safety/049-bomb.png": 2453,
	"./Safety/050-antenna.png": 2454,
	"./Shipping/aeroplane.png": 2455,
	"./Shipping/barcode.png": 2456,
	"./Shipping/box-1.png": 2457,
	"./Shipping/box.png": 2458,
	"./Shipping/boxes.png": 2459,
	"./Shipping/calendar.png": 2460,
	"./Shipping/clipboard.png": 2461,
	"./Shipping/container.png": 2462,
	"./Shipping/delivery-1.png": 2463,
	"./Shipping/delivery-2.png": 2464,
	"./Shipping/delivery-3.png": 2465,
	"./Shipping/delivery-truck.png": 2466,
	"./Shipping/delivery.png": 2467,
	"./Shipping/envelope.png": 2468,
	"./Shipping/find.png": 2469,
	"./Shipping/fragile.png": 2470,
	"./Shipping/gift.png": 2471,
	"./Shipping/laptop.png": 2472,
	"./Shipping/package-1.png": 2473,
	"./Shipping/package-2.png": 2474,
	"./Shipping/package-3.png": 2475,
	"./Shipping/package-4.png": 2476,
	"./Shipping/package-5.png": 2477,
	"./Shipping/package-6.png": 2478,
	"./Shipping/package-7.png": 2479,
	"./Shipping/package.png": 2480,
	"./Shipping/route.png": 2481,
	"./Shipping/safety.png": 2482,
	"./Shipping/ship.png": 2483,
	"./Shipping/shipping.png": 2484,
	"./Shipping/smartphone.png": 2485,
	"./Shipping/stroller.png": 2486,
	"./Shipping/support.png": 2487,
	"./Shipping/train.png": 2488,
	"./Shipping/up.png": 2489,
	"./Shipping/warehouse-1.png": 2490,
	"./Shipping/warehouse-2.png": 2491,
	"./Shipping/warehouse.png": 2492,
	"./Shipping/weight.png": 2493,
	"./Shipping/worldwide.png": 2494,
	"./Tools/atomic.png": 2495,
	"./Tools/awl.png": 2496,
	"./Tools/axe.png": 2497,
	"./Tools/barrels.png": 2498,
	"./Tools/battery-1.png": 2499,
	"./Tools/battery.png": 2500,
	"./Tools/box.png": 2501,
	"./Tools/charging.png": 2502,
	"./Tools/chisel.png": 2503,
	"./Tools/clamp.png": 2504,
	"./Tools/coal.png": 2505,
	"./Tools/compass.png": 2506,
	"./Tools/cutter.png": 2507,
	"./Tools/driller.png": 2508,
	"./Tools/ecology.png": 2509,
	"./Tools/electric-car.png": 2510,
	"./Tools/electric-tower.png": 2511,
	"./Tools/eolic-energy.png": 2512,
	"./Tools/factory.png": 2513,
	"./Tools/faucet.png": 2514,
	"./Tools/file.png": 2515,
	"./Tools/gas-station.png": 2516,
	"./Tools/gas.png": 2517,
	"./Tools/glue.png": 2518,
	"./Tools/hammer-1.png": 2519,
	"./Tools/hammer-2.png": 2520,
	"./Tools/hammer.png": 2521,
	"./Tools/house.png": 2522,
	"./Tools/hydro-power.png": 2523,
	"./Tools/jigsaw.png": 2524,
	"./Tools/ladder.png": 2525,
	"./Tools/level.png": 2526,
	"./Tools/light-bulb.png": 2527,
	"./Tools/low-battery.png": 2528,
	"./Tools/marker.png": 2529,
	"./Tools/mat.png": 2530,
	"./Tools/measuring-tape.png": 2531,
	"./Tools/nail.png": 2532,
	"./Tools/needle.png": 2533,
	"./Tools/nut.png": 2534,
	"./Tools/oil-platform.png": 2535,
	"./Tools/paint-brush-1.png": 2536,
	"./Tools/paint-brush-2.png": 2537,
	"./Tools/paint-brush.png": 2538,
	"./Tools/paint-bucket.png": 2539,
	"./Tools/paint-palette.png": 2540,
	"./Tools/paint-roller.png": 2541,
	"./Tools/pantone.png": 2542,
	"./Tools/pencil.png": 2543,
	"./Tools/pliers-1.png": 2544,
	"./Tools/pliers-2.png": 2545,
	"./Tools/pliers.png": 2546,
	"./Tools/plug.png": 2547,
	"./Tools/power-button.png": 2548,
	"./Tools/power-plant.png": 2549,
	"./Tools/rain.png": 2550,
	"./Tools/recycle.png": 2551,
	"./Tools/renewable-energy-1.png": 2552,
	"./Tools/renewable-energy.png": 2553,
	"./Tools/ruler-1.png": 2554,
	"./Tools/ruler.png": 2555,
	"./Tools/save-energy.png": 2556,
	"./Tools/saw-1.png": 2557,
	"./Tools/saw.png": 2558,
	"./Tools/scissors.png": 2559,
	"./Tools/screw.png": 2560,
	"./Tools/screwdriver.png": 2561,
	"./Tools/set-square.png": 2562,
	"./Tools/shovel-1.png": 2563,
	"./Tools/shovel.png": 2564,
	"./Tools/socket.png": 2565,
	"./Tools/solar-energy.png": 2566,
	"./Tools/spatula.png": 2567,
	"./Tools/tape.png": 2568,
	"./Tools/toolbox.png": 2569,
	"./Tools/usb-cable.png": 2570,
	"./Tools/workplace.png": 2571,
	"./Tools/wrench-1.png": 2572,
	"./Tools/wrench-2.png": 2573,
	"./Tools/wrench.png": 2574,
	"./Traffic/001-highway-1.png": 2575,
	"./Traffic/002-two-ways.png": 2576,
	"./Traffic/003-road-sign.png": 2577,
	"./Traffic/004-barrier.png": 2578,
	"./Traffic/005-right-arrow.png": 2579,
	"./Traffic/006-roundabout.png": 2580,
	"./Traffic/007-prohibition.png": 2581,
	"./Traffic/008-curves.png": 2582,
	"./Traffic/009-intersection-3.png": 2583,
	"./Traffic/010-caravan-1.png": 2584,
	"./Traffic/011-caravan.png": 2585,
	"./Traffic/012-highway.png": 2586,
	"./Traffic/013-traffic-sign-1.png": 2587,
	"./Traffic/014-traffic-sign.png": 2588,
	"./Traffic/015-warning-2.png": 2589,
	"./Traffic/016-gas-station.png": 2590,
	"./Traffic/017-turn-right-2.png": 2591,
	"./Traffic/018-coffee-shop.png": 2592,
	"./Traffic/019-bicycle-1.png": 2593,
	"./Traffic/020-bicycle.png": 2594,
	"./Traffic/021-bump.png": 2595,
	"./Traffic/022-intersection-2.png": 2596,
	"./Traffic/023-turn-1.png": 2597,
	"./Traffic/024-turn-right-1.png": 2598,
	"./Traffic/025-turn-left-1.png": 2599,
	"./Traffic/026-intersection-1.png": 2600,
	"./Traffic/027-intersection.png": 2601,
	"./Traffic/028-waiting.png": 2602,
	"./Traffic/029-horn.png": 2603,
	"./Traffic/030-narrow-road.png": 2604,
	"./Traffic/031-warning-1.png": 2605,
	"./Traffic/032-hill.png": 2606,
	"./Traffic/033-truck.png": 2607,
	"./Traffic/034-pedestrian-2.png": 2608,
	"./Traffic/035-pedestrian-1.png": 2609,
	"./Traffic/036-traffic-light.png": 2610,
	"./Traffic/037-turn.png": 2611,
	"./Traffic/038-slippery.png": 2612,
	"./Traffic/039-no-entry.png": 2613,
	"./Traffic/040-speed-limit.png": 2614,
	"./Traffic/041-humps.png": 2615,
	"./Traffic/042-falling-rocks.png": 2616,
	"./Traffic/043-pedestrian.png": 2617,
	"./Traffic/044-turn-right.png": 2618,
	"./Traffic/045-turn-left.png": 2619,
	"./Traffic/046-u-turn.png": 2620,
	"./Traffic/047-warning.png": 2621,
	"./Traffic/048-no-parking.png": 2622,
	"./Traffic/049-parking.png": 2623,
	"./Traffic/050-danger.png": 2624,
	"./Trailers/BoxTrailer_Black.png": 2625,
	"./Trailers/BoxTrailer_Blue.png": 2626,
	"./Trailers/BoxTrailer_Green.png": 2627,
	"./Trailers/BoxTrailer_Grey.png": 2628,
	"./Trailers/BoxTrailer_Red.png": 2629,
	"./Trailers/BoxTrailer_Yellow.png": 2630,
	"./Trailers/Caravan_Black.png": 2631,
	"./Trailers/Caravan_Blue.png": 2632,
	"./Trailers/Caravan_Green.png": 2633,
	"./Trailers/Caravan_Grey.png": 2634,
	"./Trailers/Caravan_Red.png": 2635,
	"./Trailers/Caravan_Yellow.png": 2636,
	"./Trailers/FullTrailer_Black.png": 2637,
	"./Trailers/FullTrailer_Blue.png": 2638,
	"./Trailers/FullTrailer_Green.png": 2639,
	"./Trailers/FullTrailer_Grey.png": 2640,
	"./Trailers/FullTrailer_Red.png": 2641,
	"./Trailers/FullTrailer_Yellow.png": 2642,
	"./Trailers/SuperSilentGeneratorTrailer_Black.png": 2643,
	"./Trailers/SuperSilentGeneratorTrailer_Blue.png": 2644,
	"./Trailers/SuperSilentGeneratorTrailer_Green.png": 2645,
	"./Trailers/SuperSilentGeneratorTrailer_Grey.png": 2646,
	"./Trailers/SuperSilentGeneratorTrailer_Red.png": 2647,
	"./Trailers/SuperSilentGeneratorTrailer_Yellow.png": 2648,
	"./Trailers/TankerTrailer_Black.png": 2649,
	"./Trailers/TankerTrailer_Blue.png": 2650,
	"./Trailers/TankerTrailer_Green.png": 2651,
	"./Trailers/TankerTrailer_Grey.png": 2652,
	"./Trailers/TankerTrailer_Red.png": 2653,
	"./Trailers/TankerTrailer_Yellow.png": 2654,
	"./Trailers/TravelTrailer_Black.png": 2655,
	"./Trailers/TravelTrailer_Blue.png": 2656,
	"./Trailers/TravelTrailer_Green.png": 2657,
	"./Trailers/TravelTrailer_Grey.png": 2658,
	"./Trailers/TravelTrailer_Red.png": 2659,
	"./Trailers/TravelTrailer_Yellow.png": 2660,
	"./Trailers/WaterBowserTrailer_Black.png": 2661,
	"./Trailers/WaterBowserTrailer_Blue.png": 2662,
	"./Trailers/WaterBowserTrailer_Green.png": 2663,
	"./Trailers/WaterBowserTrailer_Grey.png": 2664,
	"./Trailers/WaterBowserTrailer_Red.png": 2665,
	"./Trailers/WaterBowserTrailer_Yellow.png": 2666,
	"./Transportation/aeroplane.png": 2667,
	"./Transportation/airplane.png": 2668,
	"./Transportation/auto-ricksaw.png": 2669,
	"./Transportation/bike.png": 2670,
	"./Transportation/boat.png": 2671,
	"./Transportation/bus-1.png": 2672,
	"./Transportation/bus.png": 2673,
	"./Transportation/cable-car-cabin.png": 2674,
	"./Transportation/car-1.png": 2675,
	"./Transportation/car-2.png": 2676,
	"./Transportation/car-3.png": 2677,
	"./Transportation/car.png": 2678,
	"./Transportation/catamaran.png": 2679,
	"./Transportation/chairlift.png": 2680,
	"./Transportation/classic-car.png": 2681,
	"./Transportation/helicopter.png": 2682,
	"./Transportation/hot-air-balloon.png": 2683,
	"./Transportation/jeep.png": 2684,
	"./Transportation/locomotive.png": 2685,
	"./Transportation/lorry.png": 2686,
	"./Transportation/minibus.png": 2687,
	"./Transportation/monorail.png": 2688,
	"./Transportation/motorbike.png": 2689,
	"./Transportation/quad.png": 2690,
	"./Transportation/sailboat.png": 2691,
	"./Transportation/sailing-ship.png": 2692,
	"./Transportation/school-bus.png": 2693,
	"./Transportation/ship-1.png": 2694,
	"./Transportation/ship-2.png": 2695,
	"./Transportation/ship-3.png": 2696,
	"./Transportation/ship.png": 2697,
	"./Transportation/sidecar.png": 2698,
	"./Transportation/spaceship.png": 2699,
	"./Transportation/sportive-car.png": 2700,
	"./Transportation/submarine.png": 2701,
	"./Transportation/taxi-1.png": 2702,
	"./Transportation/taxi.png": 2703,
	"./Transportation/tractor.png": 2704,
	"./Transportation/train-1.png": 2705,
	"./Transportation/train-2.png": 2706,
	"./Transportation/train.png": 2707,
	"./Transportation/tram.png": 2708,
	"./Transportation/tricycle.png": 2709,
	"./Transportation/trolleybus.png": 2710,
	"./Transportation/truck.png": 2711,
	"./Transportation/ufo.png": 2712,
	"./Transportation/underground.png": 2713,
	"./Transportation/van-1.png": 2714,
	"./Transportation/van.png": 2715,
	"./Transportation/zeppelin.png": 2716,
	"./Trucks/BinTruck_Black.png": 2717,
	"./Trucks/BinTruck_Blue.png": 2718,
	"./Trucks/BinTruck_Green.png": 2719,
	"./Trucks/BinTruck_Grey.png": 2720,
	"./Trucks/BinTruck_Red.png": 2721,
	"./Trucks/BinTruck_Yellow.png": 2722,
	"./Trucks/FuelTankTruck_Black.png": 2723,
	"./Trucks/FuelTankTruck_Blue.png": 2724,
	"./Trucks/FuelTankTruck_Green.png": 2725,
	"./Trucks/FuelTankTruck_Grey.png": 2726,
	"./Trucks/FuelTankTruck_Red.png": 2727,
	"./Trucks/FuelTankTruck_Yellow.png": 2728,
	"./Trucks/HaulTruck_Black.png": 2729,
	"./Trucks/HaulTruck_Blue.png": 2730,
	"./Trucks/HaulTruck_Green.png": 2731,
	"./Trucks/HaulTruck_Grey.png": 2732,
	"./Trucks/HaulTruck_Red.png": 2733,
	"./Trucks/HaulTruck_Yellow.png": 2734,
	"./Trucks/LorryCab_Black.png": 2735,
	"./Trucks/LorryCab_Blue.png": 2736,
	"./Trucks/LorryCab_Green.png": 2737,
	"./Trucks/LorryCab_Grey.png": 2738,
	"./Trucks/LorryCab_Red.png": 2739,
	"./Trucks/LorryCab_Yellow.png": 2740,
	"./Trucks/LorryTrailer_Black.png": 2741,
	"./Trucks/LorryTrailer_Blue.png": 2742,
	"./Trucks/LorryTrailer_Green.png": 2743,
	"./Trucks/LorryTrailer_Grey.png": 2744,
	"./Trucks/LorryTrailer_Red.png": 2745,
	"./Trucks/LorryTrailer_Yellow.png": 2746,
	"./Trucks/Lorry_Black.png": 2747,
	"./Trucks/Lorry_Blue.png": 2748,
	"./Trucks/Lorry_Green.png": 2749,
	"./Trucks/Lorry_Grey.png": 2750,
	"./Trucks/Lorry_Red.png": 2751,
	"./Trucks/Lorry_Yellow.png": 2752,
	"./Trucks/PetroleumTankTruck_Black.png": 2753,
	"./Trucks/PetroleumTankTruck_Blue.png": 2754,
	"./Trucks/PetroleumTankTruck_Green.png": 2755,
	"./Trucks/PetroleumTankTruck_Grey.png": 2756,
	"./Trucks/PetroleumTankTruck_Red.png": 2757,
	"./Trucks/PetroleumTankTruck_Yellow.png": 2758,
	"./Trucks/SkipTruck_Black.png": 2759,
	"./Trucks/SkipTruck_Blue.png": 2760,
	"./Trucks/SkipTruck_Green.png": 2761,
	"./Trucks/SkipTruck_Grey.png": 2762,
	"./Trucks/SkipTruck_Red.png": 2763,
	"./Trucks/SkipTruck_Yellow.png": 2764,
	"./Trucks/TankerTruck_Black.png": 2765,
	"./Trucks/TankerTruck_Blue.png": 2766,
	"./Trucks/TankerTruck_Green.png": 2767,
	"./Trucks/TankerTruck_Grey.png": 2768,
	"./Trucks/TankerTruck_Red.png": 2769,
	"./Trucks/TankerTruck_Yellow.png": 2770,
	"./Trucks/TractorTrailer2_Black.png": 2771,
	"./Trucks/TractorTrailer2_Blue.png": 2772,
	"./Trucks/TractorTrailer2_Green.png": 2773,
	"./Trucks/TractorTrailer2_Grey.png": 2774,
	"./Trucks/TractorTrailer2_Red.png": 2775,
	"./Trucks/TractorTrailer2_Yellow.png": 2776,
	"./Trucks/TractorTrailer_Black.png": 2777,
	"./Trucks/TractorTrailer_Blue.png": 2778,
	"./Trucks/TractorTrailer_Green.png": 2779,
	"./Trucks/TractorTrailer_Grey.png": 2780,
	"./Trucks/TractorTrailer_Red.png": 2781,
	"./Trucks/TractorTrailer_Yellow.png": 2782,
	"./Trucks/TruckV_Black.png": 2783,
	"./Trucks/TruckV_Blue.png": 2784,
	"./Trucks/TruckV_Green.png": 2785,
	"./Trucks/TruckV_Grey.png": 2786,
	"./Trucks/TruckV_Red.png": 2787,
	"./Trucks/TruckV_Yellow.png": 2788,
	"./Trucks/Truck_Black.png": 2789,
	"./Trucks/Truck_Blue.png": 2790,
	"./Trucks/Truck_Green.png": 2791,
	"./Trucks/Truck_Grey.png": 2792,
	"./Trucks/Truck_Red.png": 2793,
	"./Trucks/Truck_Yellow.png": 2794,
	"./Watercraft/Barge_Black.png": 2795,
	"./Watercraft/Barge_Blue.png": 2796,
	"./Watercraft/Barge_Green.png": 2797,
	"./Watercraft/Barge_Grey.png": 2798,
	"./Watercraft/Barge_Red.png": 2799,
	"./Watercraft/Barge_Yellow.png": 2800,
	"./Watercraft/Boat_Black.png": 2801,
	"./Watercraft/Boat_Blue.png": 2802,
	"./Watercraft/Boat_Gray.png": 2803,
	"./Watercraft/Boat_Green.png": 2804,
	"./Watercraft/Boat_Red.png": 2805,
	"./Watercraft/Boat_Yellow.png": 2806,
	"./Watercraft/BulkCarrier_Black.png": 2807,
	"./Watercraft/BulkCarrier_Blue.png": 2808,
	"./Watercraft/BulkCarrier_Green.png": 2809,
	"./Watercraft/BulkCarrier_Grey.png": 2810,
	"./Watercraft/BulkCarrier_Red.png": 2811,
	"./Watercraft/BulkCarrier_Yellow.png": 2812,
	"./Watercraft/Motorboat_Black.png": 2813,
	"./Watercraft/Motorboat_Blue.png": 2814,
	"./Watercraft/Motorboat_Green.png": 2815,
	"./Watercraft/Motorboat_Grey.png": 2816,
	"./Watercraft/Motorboat_Red.png": 2817,
	"./Watercraft/Motorboat_Yellow.png": 2818,
	"./Watercraft/Sailboat_Black.png": 2819,
	"./Watercraft/Sailboat_Blue.png": 2820,
	"./Watercraft/Sailboat_Green.png": 2821,
	"./Watercraft/Sailboat_Grey.png": 2822,
	"./Watercraft/Sailboat_Red.png": 2823,
	"./Watercraft/Sailboat_Yellow.png": 2824,
	"./Watercraft/Tanker_Black.png": 2825,
	"./Watercraft/Tanker_Blue.png": 2826,
	"./Watercraft/Tanker_Green.png": 2827,
	"./Watercraft/Tanker_Grey.png": 2828,
	"./Watercraft/Tanker_Red.png": 2829,
	"./Watercraft/Tanker_Yellow.png": 2830,
	"./Watercraft/WaterMotorcycle_Black.png": 2831,
	"./Watercraft/WaterMotorcycle_Blue.png": 2832,
	"./Watercraft/WaterMotorcycle_Green.png": 2833,
	"./Watercraft/WaterMotorcycle_Grey.png": 2834,
	"./Watercraft/WaterMotorcycle_Red.png": 2835,
	"./Watercraft/WaterMotorcycle_Yellow.png": 2836
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54;